const controls = {
  data() {
    return {
      showModal: false,
    }
  },
  watch: {
    showModal: {
      handler(data) {
        if (data === false) {
          document.body.style.overflow = 'scroll'
        } else {
          document.body.style.overflow = 'hidden'
        }
      },
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}

export { controls }
